// scale
let scale = [8]

for (var i = 0; i < 18; i++) {
  scale[i + 1] = scale[i] + (parseInt((i - 2) / 4) + 1) * 2
}

// get rid of 8 and 10px font sizes
scale.splice(0, 2)

// colors
// @todo these do not correspond to either grey or black palette colors
const whiteOpacity = [1, 0.6, 0.38]
const blackOpacity = [0.87, 0.6, 0.38, 0.1]
const blackRGB = [27, 31, 35]
const whiteRGB = [255, 255, 255]

const theme = {
  // mostly matches the current breakpoints for .org as defined in
  // https://github.com/gatsbyjs/gatsby/blob/a420eb40451fcf7652432b53387dab0a27b64472/www/src/utils/presets.js#L5-L16
  // - added `xxs`
  // - dropped `VHd` (1450px)
  breakpoints: {
    xxs: 0,
    xs: 400,
    sm: 550,
    md: 750,
    lg: 1000,
    xl: 1200,
    xxl: 1650,
  },
  borders: [0, `1px solid`, `2px solid`],
  colors: {
    purple: {
      900: '#362066',
      800: '#452475',
      700: '#542C85',
      600: '#663399',
      500: '#8a4baf', // #8954A8
      400: '#B17ACC',
      300: '#D9BAE8',
      200: '#F1DEFA',
      100: '#F6EDFA',
      50: '#FCFAFF',
    },
    orange: {
      900: '#db3a00', // #E34200
      800: '#e65800', // #F06200
      700: '#F67300',
      600: '#FB8400',
      500: '#FFB238',
      400: '#FFD280',
      300: '#FFE4A1',
      200: '#FFEDBF',
      100: '#FFF4DB',
      50: '#FFFCF7',
    },
    yellow: {
      900: '#8A6534',
      800: '#BF9141',
      700: '#E3A617',
      600: '#FEC21E',
      500: '#FED038',
      400: '#FFDF37',
      300: '#FFEB99',
      200: '#FFF2A8',
      100: '#FFF5BF',
      50: '#FFFDF7',
    },
    red: {
      900: '#B80000',
      800: '#CE0009',
      700: '#DA0013',
      600: '#EC1818',
      500: '#FA2915',
      400: '#FF5A54',
      300: '#FF8885',
      200: '#FFBAB8',
      100: '#FDE7E7',
      50: '#FFFAFA',
    },
    magenta: {
      900: '#690147',
      800: '#7D0E59',
      700: '#940159',
      600: '#A6026A',
      500: '#BC027F',
      400: '#D459AB',
      300: '#E899CE',
      200: '#F2C4E3',
      100: '#FFE6F6',
      50: '#FFFAFD',
    },
    blue: {
      900: '#004CA3',
      800: '#006AC1',
      700: '#047BD3',
      600: '#0E8DE6',
      500: '#0d96f2', // #159BF3
      400: '#3FA9F5',
      300: '#63B8F6',
      200: '#90CDF9',
      100: '#DBF0FF',
      50: '#F5FCFF',
    },
    teal: {
      900: '#008577', // #008E80
      800: '#10A39E',
      700: '#00BDB6',
      600: '#2DE3DA',
      500: '#05F7F4',
      400: '#73FFF7',
      300: '#A6FFFA',
      200: '#CCFFFC',
      100: '#DCFFFD',
      50: '#F7FFFF',
    },
    green: {
      900: '#006500',
      800: '#088413',
      700: '#1D9520',
      600: '#2CA72C',
      500: '#37B635',
      400: '#59C156',
      300: '#79CD75',
      200: '#A1DA9E',
      100: '#DEF5DC',
      50: '#F7FDF7',
    },
    grey: {
      900: '#232129',
      800: '#36313D',
      700: '#48434F',
      600: '#635E69',
      500: '#7F7C82',
      400: '#B7B5BD',
      300: '#D9D7E0',
      200: '#F0F0F2',
      100: '#F5F5F5',
      50: '#FBFBFB',
    },
    // @todo properly handle rgba colors
    black: {
      900: '#000',
      800: `rgba(${blackRGB.join(',')}, ${blackOpacity[0]})`,
      700: `rgba(${blackRGB.join(',')}, ${blackOpacity[1]})`,
      600: `rgba(${blackRGB.join(',')}, ${blackOpacity[2]})`,
      100: `rgba(${blackRGB.join(',')}, ${blackOpacity[3]})`,
    },
    white: {
      900: '#fff',
      800: `rgba(${whiteRGB.join(',')}, ${whiteOpacity[0]})`,
      700: `rgba(${whiteRGB.join(',')}, ${whiteOpacity[1]})`,
      600: `rgba(${whiteRGB.join(',')}, ${whiteOpacity[2]})`,
    },
  },
  // https://github.com/gatsbyjs/gatsby/blob/a420eb40451fcf7652432b53387dab0a27b64472/www/src/utils/typography.js#L5-L46
  fonts: {
    brand: `Futura PT, -apple-system, BlinkMacSystemFont, "avenir next", avenir, "helvetica neue", helvetica, ubuntu, roboto, noto, "segoe ui", arial, sans-serif`,
    monospace: `SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace`,
    sansSerif: `-apple-system, BlinkMacSystemFont, "avenir next", avenir, "helvetica neue", helvetica, ubuntu, roboto, noto, "segoe ui", arial, sans-serif`,
    serif: `Spectral, Georgia, Times New Roman, Times, serif`,
  },
  fontSizes: scale,
  fontWeights: [400, 700, 800],
  letterSpacings: {
    normal: `normal`,
    tracked: `0.075em`,
    tight: `-0.015em`,
    mega: `0.25em`,
  },
  lineHeights: {
    solid: 1,
    title: 1.25,
    copy: 1.5,
  },
  // https://github.com/gatsbyjs/gatsby/blob/a420eb40451fcf7652432b53387dab0a27b64472/www/src/utils/presets.js#L19-L20
  radii: [0, 2, 4, 8, 16, 9999, `100%`],
  // @todo check spacing scale
  // @todo hook up to typography.js
  // @todo rem instead of px
  space: [0, 4, 8, 16, 20, 32, 40, 64, 80, 128, 256, 512],
  // @todo didn't manage to get these to work yet
  textStyles: {
    caps: {
      letterSpacing: '0.2em',
      textTransform: 'uppercase',
    },
  },
  shadows: [
    '0px 1px 2px rgba(46, 41, 51, 0.08), 0px 2px 4px rgba(71, 63, 79, 0.08)',
  ],
}

export default theme
